import React from "react";
import styled from "styled-components/macro";
import { colors } from "theme/Theme";
import { DefaultText } from "theme/GlobalElements";

export const buttonType = {
  defaultBtn: {
    fontColor: "black",
    color: colors.gray,
    hoverColor: colors.dark_gray,
  },
  whiteBtn: {
    fontColor: "black",
    color: "white",
    hoverColor: colors.dark_gray,
  },
  blueBtn: {
    fontColor: "white",
    color: colors.lighter_blue,
    hoverColor: colors.light_blue,
  },
  dangerBtn: {
    fontColor: "white",
    color: colors.gray,
    hoverColor: "red",
  },
};

interface ButtonProps {
  title?: string;
  rounded?: boolean;
  children?: any;
  type: any;
  disabled?: boolean;
  onClick?: (e: any) => void;
  classNames?: string;
  fontSizeClass?: string;
}

const Button: React.FC<ButtonProps> = ({
  title,
  rounded = true,
  children,
  type,
  disabled = false,
  onClick,
  classNames,
  fontSizeClass = "text-body",
}) => {
  return (
    <ButtonContainer
      className={`${disabled ? "disabled" : "active"} ${classNames}`}
      type={type}
      rounded={rounded}
      onClick={onClick}
    >
      {children}
      <DefaultText className={fontSizeClass} color={type.fontColor}>
        {title}
      </DefaultText>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div<{ type: any; rounded: boolean }>`
  cursor: pointer;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  padding: 5px 10px;
  background-color: ${(props) => props.type.color};
  border-radius: ${(props) => (props.rounded ? "5px" : "0px")};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  &.active {
    &:hover {
      background-color: ${(props) => props.type.hoverColor};
    }
  }
  &.disabled {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
    background: #ccc;
    &:hover {
      background-color: ${(props) => props.type.color};
    }
  }
`;

export default Button;
